import { NSButton } from 'bricks';
import React, { useState } from 'react';
import {
    Dropdown, DropdownToggle,
    DropdownItem,
    DropdownMenu,
} from 'reactstrap';
import {
    faDownload, faEdit, faEllipsisVertical, faTrash,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IDocumentActionOptionsProps {
    onDownload: () => void;
    isFile: boolean;
    onDelete: any
    onEdit: (e: React.MouseEvent) => void;
}

const DocumentActionOptions = ({
    onDownload, isFile, onDelete, onEdit,
}: IDocumentActionOptionsProps) => {
    const [openOptions, setOpenOptions] = useState(false);

    return (
        <Dropdown className="FileTileCard__dropdown" isOpen={openOptions} toggle={() => setOpenOptions(!openOptions)} direction="down">
            <DropdownToggle tag="button" className="FileTileCard__dropdown-toggle mt-1">
                <NSButton color="secondary-lighten" icon={faEllipsisVertical} />
            </DropdownToggle>
            <DropdownMenu>
                {isFile && (
                    <DropdownItem onClick={onDownload} data-testid="download-action" className="text-white">
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <span>Download</span>
                            <FontAwesomeIcon icon={faDownload} />
                        </div>
                    </DropdownItem>
                )}
                <DropdownItem onClick={onEdit} data-testid="edit-action" className="text-white">
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <span>Edit</span>
                        <FontAwesomeIcon icon={faEdit} />
                    </div>
                </DropdownItem>
                <DropdownItem onClick={onDelete} data-testid="delete-action" className="text-white">
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <span>Delete</span>
                        <FontAwesomeIcon icon={faTrash} />
                    </div>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default DocumentActionOptions;
